import CloseButton from '../CloseButton';
import { TextEllipsis } from 'components/Kizen/Table';
import {
  StyledModalBody,
  StyledModalHeader,
  StyledModalFooter,
  StyledModal,
} from './styles';

export const _modalSize = {
  small: 400,
  medium: 900,
  large: 1200,
  columns_editor: 1052,
};

export const modalSize = {
  small: _modalSize.small + 'px',
  medium: _modalSize.medium + 'px',
  large: _modalSize.large + 'px',
  columns_editor: _modalSize.columns_editor + 'px',
};

const Modal = ({ className, size, ...props }) => (
  <StyledModal
    // This class is used by robert to identify new modal components
    className={`StandardModal ${className || ''}`}
    centered
    size="lg" // for resolving size conflict between react-bootstrap and our custom size
    animation={false}
    width={modalSize[size]}
    {...props}
  />
);

Modal.defaultProps = {
  fitContent: 'y',
  fitContentWidth: 'fit-content',
  size: 'small',
};

export const ModalHeader = ({
  children,
  className,
  onClickClose,
  showHeaderCloseButton = true,
  ...others
}) => (
  <StyledModalHeader className={`modal-header ${className || ''}`} {...others}>
    <TextEllipsis type="subheader" className="modal-title">
      {children}
    </TextEllipsis>
    {showHeaderCloseButton ? <CloseButton onClick={onClickClose} /> : null}
  </StyledModalHeader>
);

export const ModalBody = StyledModalBody;
export const ModalFooter = StyledModalFooter;

export default Modal;
